import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.png";
import Tilt from "react-parallax-tilt";
import { AiFillGithub, AiOutlineTwitter, AiFillInstagram } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { useScrollReveal } from "../../hooks/useScrollReveal";

function Home2() {
  useScrollReveal();

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row className="align-items-center">
          <Col md={8} className="home-about-description">
            <p className="reveal" style={{ color: "rgba(232,224,240,0.4)", fontSize: "0.85em", letterSpacing: "0.15em", textTransform: "uppercase" }}>
              About me
            </p>
            <h1 className="reveal reveal-delay-1">
              LET ME <span className="purple">INTRODUCE</span> MYSELF
            </h1>
            <p className="home-about-body reveal reveal-delay-2">
              I'm a <strong style={{ color: "rgba(232,224,240,0.9)" }}>Software Engineering student</strong> at SUPINFO International University,
              currently working as a <span className="purple">Full Stack ERP Developer</span> at SEALERIS in Rennes, France.
              <br /><br />
              My expertise spans <span className="purple">Full Stack development</span>, <span className="purple">Cloud architecture</span>,
              and <span className="purple">DevSecOps</span>. I love building systems that are fast, secure, and elegant —
              from custom Odoo modules to scalable React/Node applications.
              <br /><br />
              Beyond code, I'm into gaming, music, and camping. I believe great software is built by people who stay curious.
            </p>
          </Col>
          <Col md={4} className="myAvtar reveal reveal-delay-3">
            <Tilt glareEnable={true} glareMaxOpacity={0.1} glareColor="#b44fff" glareBorderRadius="20px" tiltMaxAngleX={8} tiltMaxAngleY={8}>
              <img src={myImg} className="img-fluid" alt="Marwen avatar" style={{ borderRadius: "20px" }} />
            </Tilt>
          </Col>
        </Row>

        <Row>
          <Col md={12} className="home-about-social reveal">
            <h1>FIND ME ON</h1>
            <p style={{ color: "rgba(232,224,240,0.5)", marginBottom: "1.5rem" }}>
              Feel free to <span className="purple">connect</span> with me
            </p>
            <ul className="home-about-social-links">
              {[
                { href: "https://github.com/TheAgentMaro",          icon: <AiFillGithub />,      label: "GitHub"    },
                { href: "https://twitter.com/MarwenMeddeb9",         icon: <AiOutlineTwitter />,   label: "Twitter"   },
                { href: "https://www.linkedin.com/in/marwen-meddeb/",icon: <FaLinkedinIn />,       label: "LinkedIn"  },
                { href: "https://www.instagram.com/_marwen_meddeb_/",icon: <AiFillInstagram />,    label: "Instagram" },
              ].map(({ href, icon, label }) => (
                <li key={label} className="social-icons">
                  <a
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                    className="home-social-icons"
                    aria-label={label}
                  >
                    {icon}
                  </a>
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;